const themeColors = {
  kroemtech: {
    green: '#0BE318',
    greenBlue: '#00E362',
    blueGreen: '#0BE3B9',
    blue: '#00C6EF',
    lightBlue: '#54eeff',
    background: '#ffffff',
    sensBlue: '#606EA0',
    dunkelblau: '#121139',
    navy: '#0D244C',
    scygate: '#e60055',
    dathascy: '#02d159',
    scycloud: '#11a5f5'
  },

  // Cool off-white for the alternating bands on the OT service pages.
  // `lightRgb` is the same colour as a triplet, for gradients needing an alpha.
  section: {
    light: '#F3F7FA',
    lightRgb: '243, 247, 250'
  },

  bg: {
    extraLight: '#bfc5e4',
    light: '#8f9de3',
    start: '#5a6dcd',
    end: '#463264',
    lightEnd: '#7aa8d327'
  },

  gray: {
    lightest: '#f5f5f5',
    lighter: '#dcdcdc',
    light: '#c8c8c8',
    mid: '#646464',
    darker: '#454545',
    dark: '#323232',
    darkBg: '#525353',
    lightBg: '#f3f2f7',
    defaultText: '#57595c',
    100: '#f6f9fc',
    200: '#dcdfe2',
    300: '#bbbec1',
    400: '#9c9fa2',
    500: '#7f8285',
    600: '#6b6e71',
    700: '#57595c',
    800: '#454749',
    900: '#232527'
  },
  blue: {
    badge: '#00aeff',
    badgeSelected: '#007ebd',
    badgeHover: '#00aeffcc',
    editorCollapseBorder: '#bde9fc'
  },
  success: {
    main: '#2dce89',
    darker: '#07b86c'
  },

  info: {
    lightest: '#ebedf2',
    main: '#0059ff'
  },

  error: {
    main: '#ff3246'
  },

  warning: {
    main: '#ff9500',
    light: '#f7e011'
  }
}

export default themeColors
